import { EventsService } from 'src/app/core/services/events.service';
import { GoogleMapType } from '../enums/google-map-enum';
import { IGoogleMap } from 'src/app/core/models/google-map-models';
import { GoogleMapConfigService } from '../services/google-map-config/google-map-config.service';

export class GoogleMapBase extends EventsService {

    public mapType: GoogleMapType;
    public googleMap: IGoogleMap;

    public mapConfig: GoogleMapConfigService;

    constructor(mapType) {
        super();
        this.mapType = mapType;
    }

    public validateThisMap(mapType: GoogleMapType): boolean {
      return this.mapType === mapType;
    }

    public destroy(): void {
      this.removeGoogleMapEvent();
    }

    // sort by duration
    public sortRouteByDuration(routes: Array<any>) {
      routes = routes.sort( (a, b) => a.legs[0].duration.value - b.legs[0].duration.value );
      return routes;
    }

    private removeGoogleMapEvent(): void {
      google.maps.event.clearInstanceListeners(this.googleMap);
    }

  }
